import { render, staticRenderFns } from "./VoteResults.vue?vue&type=template&id=38d3f2c8&scoped=true"
import script from "./VoteResults.vue?vue&type=script&lang=js"
export * from "./VoteResults.vue?vue&type=script&lang=js"
import style0 from "./VoteResults.vue?vue&type=style&index=0&id=38d3f2c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d3f2c8",
  null
  
)

export default component.exports